import { ManageTemplates } from '../components/Settings/ManageTemplates/ManageTemplates'

export const ManageTemplatesPage = () => {
    return <ManageTemplates />
}
